import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class CommonService {
  constructor() {}

  private notify = new Subject<any>();

  /**
   * Observable string streams
   */
  notifyObservable$ = this.notify.asObservable();

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/common.service.ts